import LoadingSkeletonView from "./LoadingSkeletonView";

/**
 * Container component for LoadingSkeleton.
 * Renders the View component directly as no logic is needed.
 */
const LoadingSkeletonContainer = () => <LoadingSkeletonView />;

LoadingSkeletonContainer.displayName = "LoadingSkeletonContainer";

export default LoadingSkeletonContainer;
